module.exports = __webpack_public_path__ + "img/open.cd23a6cd.svg";